module.exports = __webpack_public_path__ + "static/media/menuMic.24b7aa75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuMic.svg
// module id = 170
// module chunks = 0